class SocketService {
    publish() {}

    getOperationResult() {}
}
module.exports = SocketService;
